import { render, staticRenderFns } from "./CustomRecruitment.vue?vue&type=template&id=82d62a6e&scoped=true"
import script from "./CustomRecruitment.vue?vue&type=script&lang=js"
export * from "./CustomRecruitment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d62a6e",
  null
  
)

export default component.exports